import { createContext, } from 'react';
import { layouts, sizes, } from './constants';
export const defaultContext = {
    layout: layouts.horizontalLayout,
    onChange: () => { },
    size: sizes.medium,
};
export const ButtonPickerContext = createContext(defaultContext);
